module.exports = __webpack_public_path__ + "media/images/carousel/metier-image-2-caddbb30ffa7493ad797a7ad7d9d2fd2.jpg";